import { Link } from "react-router-dom";
import { Mail, MapPin } from "lucide-react";
import { Logo } from "./Logo";
import { SHOW_RESULTS } from "../data/content";

const PAGES = [
    { name: "How We Help", path: "/how-we-help" },
    { name: "GrowVise 90", path: "/growvise-90" },
    { name: "NZ Market Entry", path: "/market-entry-distribution" },
    { name: "Business Health Check", path: "/business-health-check" },
    ...(SHOW_RESULTS ? [{ name: "Our Results", path: "/our-results" }] : []),
    { name: "About", path: "/about" },
    { name: "Test your website", path: "/test-your-website" },
];

export const Footer = () => (
    <footer className="bg-navy-950 border-t border-white/10" data-testid="site-footer">
        <div className="max-w-6xl mx-auto px-5 sm:px-8 py-16 grid gap-12 md:grid-cols-[1.2fr_1fr_1fr]">
            <div>
                <Logo />
                <p className="mt-6 text-sm text-slate-400 leading-relaxed max-w-xs">
                    Practical commercial advisory and hands-on implementation for New Zealand businesses. Grow your revenue. Improve your profit. Build a better business.
                </p>
            </div>
            <div>
                <p className="eyebrow mb-6">Pages</p>
                <ul className="space-y-3">
                    {PAGES.map((p) => (
                        <li key={p.path}>
                            <Link
                                to={p.path}
                                data-testid={`footer-link-${p.path.slice(1)}`}
                                className="text-sm text-slate-400 hover:text-gold-400 transition-colors duration-200"
                            >
                                {p.name}
                            </Link>
                        </li>
                    ))}
                </ul>
            </div>
            <div>
                <p className="eyebrow mb-6">Contact</p>
                <a
                    href="mailto:leo@growvise.co.nz"
                    data-testid="footer-email-link"
                    className="flex items-center gap-3 text-sm text-slate-300 hover:text-gold-400 transition-colors duration-200"
                >
                    <Mail size={16} className="text-gold-500" /> leo@growvise.co.nz
                </a>
                <p className="flex items-center gap-3 text-sm text-slate-400 mt-4">
                    <MapPin size={16} className="text-gold-500" /> Auckland, New Zealand
                </p>
                <Link to="/book-a-conversation" data-testid="footer-book-btn" className="btn-gold mt-8 text-[13px] px-5 py-2.5">
                    Book a Growth Conversation
                </Link>
            </div>
        </div>
        <div className="border-t border-white/10">
            <div className="max-w-6xl mx-auto px-5 sm:px-8 py-6 flex flex-col sm:flex-row justify-between gap-3 text-xs font-mono text-slate-500">
                <span>© 2026 GrowVise. All rights reserved.</span>
                <Link to="/privacy" className="hover:text-gold-400 transition-colors duration-200" data-testid="footer-privacy-link">
                    Privacy Policy
                </Link>
            </div>
        </div>
    </footer>
);
